/**
 * Cross-document handoff for the channel wipe (home → MPA world).
 *
 * The home page stashes the outgoing card art + current theme right before
 * `location.assign`. The world page's inline head script (see
 * `<script>` in each world index.html) reads + clears it synchronously so the
 * card art is the document's very first paint; `main-world.js` then reads the
 * cover element's dataset to run the wipe from that same image.
 */

export const CHANNEL_HANDOFF_KEY = 'sb:channel';

export function stashChannelHandoff({ image = null, theme = null } = {}) {
  try {
    sessionStorage.setItem(
      CHANNEL_HANDOFF_KEY,
      JSON.stringify({ image, theme, at: Date.now() })
    );
  } catch {
    /* private mode etc. — page falls back to a solid cover */
  }
}

/** @returns {HTMLElement|null} the inline-painted cover, if this page has one */
export function getChannelCover() {
  return document.getElementById('sbChannelCover');
}
